import React, {useLayoutEffect, useRef, useState} from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import 'assets/am-charts-5/_css/amcharts5-export.css';
import 'assets/am-charts-5/_css/amcharts5-export.min.css';
import "assets/css/charts_form_controls.css";
import moment from "moment";
import { Dialog } from "primereact/dialog";
//import rawData from "./data.json";

function WorkFlowStatus(props)  {

    const [visible, setVisible] = useState(false);
    const chartRef = useRef(null);
    let chartData = props.chartData;
    let formData = props.chartForm;
    let toolData = props.toolData;  
    let chartId = props.id;


       const data = chartData.map((entry) => {
           return {
             //machineId: object.machine_id, /** To check: machine_id does not exist in the values passed.  so, commented it.  Velmani */
             time: moment(entry.h_interval).valueOf(),
             machine_name:entry.machine_name,
             num_of_data_columns:entry.num_of_data_columns,
             num_of_data_rows_processed:entry.num_of_data_rows_processed,
             num_of_nonzero_data:entry.num_of_nonzero_data,
             wf_status_code: entry.wf_status_code,
             job_name: entry.job_name
           };
         });

         const data1 = toolData.map((entry) => {
            return {
              message_name:entry.message_name,
              message_number:entry.message_number,
              message_text:entry.message_text,
            };
          });  
         let dates = {
             dateTimeFormat: new Intl.DateTimeFormat('en-US',
               {
                 year: '2-digit', 
                 month: '2-digit',
                 day: '2-digit',
                 hour: '2-digit',
                 minute: '2-digit',
                 second: "2-digit"
               }),
             startingDateTime: new Date(formData.p_param.p_start_datetime),
             endingDateTime: new Date(formData.p_param.p_end_datetime)
           }
         
         
           /**** Initialize chartTitles as found in computed: of Vue source code machine-efficiency-by-units-produced-chart.vue */
         
           /*** 
            * Step 1 Calculate Avg values
            *         return new HourlyMachineEfficiency
              public HourlyMachineEfficiency AverageHourlyMachineEfficiency
             {
               get
               {
                 if (HourlyMachineEfficiences.Count == 0)
                 {
                   return new HourlyMachineEfficiency();
                 }
         
                 return new HourlyMachineEfficiency
                 {
                   OperationRate = decimal.Round(HourlyMachineEfficiences.Average(x => x.OperationRate), 2),
                   RunningTime   = decimal.Round(HourlyMachineEfficiences.Average(x => x.RunningTime),   2),
         
                   OnTime = decimal.Round(HourlyMachineEfficiences.Average(x => x.OnTime ?? 0), 2)
                 };
               }
             }
            **************/
         
           /****
            * Step 2 Calculate Timespan. ?? To do: need to find how it is used
            * 
            */
         
           const startingDateTimeFmt = dates.dateTimeFormat.format(dates.startingDateTime).replace(/,/g, '');
           console.log("startingDateTimeFmt", startingDateTimeFmt);
           const endingDateTimeFmt = dates.dateTimeFormat.format(dates.endingDateTime).replace(/,/g, '');
           console.log("endingDateTimeFmt", endingDateTimeFmt);
         
           /****
            * Step 2.a Calculate chartTitles
            * 
            */
           const chartTitles = {
             subTitles: {
               timeSpan: `${startingDateTimeFmt} - ${endingDateTimeFmt}`,
             },
             title: `${formData.p_param.p_process_description} ${formData.p_param.p_process_id == 100 ? formData.p_param.p_line_number+' ' : ''}Work Flow Status`
           }
         
           /****
            * Step 3 Calculate exportFilePrefix
            ***/
           const exportFilePrefix = formData.p_process_description + "-efficiency-by-time-" +
             startingDateTimeFmt + "|" + endingDateTimeFmt;
           console.log("exportFilePrefix", exportFilePrefix);
         
           /****
            * Step 4. Some logics found in watch section of vue code.
            * Note: this may be included in one of these
            * 	a. Above variables asssignments
            * 	b. Inside useLayoutEffect
            * 
            */
         
         
           function setTitles(root, chart) {
             // Set Title of the chart
             let mainTitle = am5.Label.new(root, {
               centerX: am5.p50,
               fontSize: 20,
               fontWeight: "600",
               paddingBottom: 5,
               text: chartTitles.title,
               x: am5.p50
             });   
         
         
             let subTitle = am5.Container.new(root, {
               layout: am5.GridLayout.new(root, {
                 fixedWidthGrid: true,
                 maxColumns: 3
               }),
               paddingBottom: -35,
               paddingLeft: 15,
               paddingRight: 15,
               paddingTop: -80,
               width: am5.p100,
               x: am5.p0
             });   
        
             let timespanLabel = am5.Label.new(root, {
               centerX: am5.p50,
               text: chartTitles.subTitles.timeSpan,
               x: am5.p50
             });

             subTitle.children.push(timespanLabel);
             chart.children.unshift(subTitle);
             chart.children.unshift(mainTitle);
          
           }

    useLayoutEffect(() => {
        const root = am5.Root.new(chartRef.current);
        root.utc = true;

        root.setThemes([am5themes_Animated.new(root)]);

        const chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                layout: root.verticalLayout,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                panX: true,
                panY: false,
                pinchZoomX: true,
                wheelX: "panX",
                wheelY: "zoomX"
            })
        );
        chart.plotContainer.get("background").setAll({
            stroke: am5.color("#343a40"),
            fill: am5.color("#343a40"),
            fillOpacity: 0.04
        })
        chart.zoomOutButton.set("forceHidden", true);

    setTitles(root, chart);
        let xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
            baseInterval: {
                count: 1,
                timeUnit: "hour"
            },
            gridIntervals: [
                    { timeUnit: "hour", count: 1 },
                    { timeUnit: "hour", count: 3 },
                    { timeUnit: "hour", count: 6 },
                    { timeUnit: "hour", count: 12 },
                    { timeUnit: "day", count: 1 },
                    { timeUnit: "day", count: 2 },
                    { timeUnit: "day", count: 3 },
                    { timeUnit: "day", count: 4 },
                    { timeUnit: "day", count: 5 },
                    { timeUnit: "week", count: 1 },
                    { timeUnit: "month", count: 1 },
                    { timeUnit: "month", count: 2 },
                    { timeUnit: "month", count: 3 },
                    { timeUnit: "month", count: 6 },
                    { timeUnit: "year", count: 1 },
                    { timeUnit: "year", count: 2 },
                    { timeUnit: "year", count: 5 }
                  ],
                  groupData: true,
                  groupIntervals: [
                    { timeUnit: "hour", count: 1 },
                    { timeUnit: "day", count: 1 },
                    { timeUnit: "month", count: 1 }
                  ],
                  markUnitChange: false,
                  renderer: am5xy.AxisRendererX.new(root, {
                    minGridDistance: 25
                  }),
                  tooltip: am5.Tooltip.new(root, {}),
                  tooltipLocation: 0.5
                }));
            
                xAxis.get("dateFormats")["hour"] = "MMM ddt HH:mm";
                xAxis.get("dateFormats")["day"] = "MMM ddt";
                xAxis.get("dateFormats")["month"] = "MMM yy";
            
                xAxis.get("renderer").grid.template.setAll({
                  location: 0.5,
                });
            
                xAxis.get("renderer").labels.template.setAll({
                  centerX: am5.p100,
                  centerY: am5.p50,
                  multiLocation: 0.5,
                  rotation: -45
                });

        const yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "machine_name",
                renderer: am5xy.AxisRendererY.new(root, {
                    inversed: true,
                    minGridDistance:30,
                    cellStartLocation: 0,
                    cellEndLocation: 1
                }),
                maxCount: 10,
                pan: true,
                tooltip: am5.Tooltip.new(root, {})
            })
        );
        yAxis.get("renderer").labels.template.setAll({
            rotation: 0,
            fontWeight: 400,
            textAlign: "left",
            paddingRight: 10,
            minGridDistance: 30
        });

        yAxis.children.unshift(am5.Label.new(root, {
              fontWeight: '500',
              rotation: -90,
              text: "Machines",
              textAlign: 'center',
              y: am5.p50
            }));

        const uniqueMachines = Array.from(new Set(data.map(item => item.machine_name)));
        
        yAxis.data.setAll(uniqueMachines.map(machine_name => ({ machine_name })));

        yAxis.get("renderer").labels.template.setAll({
            textAlign: "left",
            // oversizedBehavior: "wrap",
            maxWidth: 150,
        });
        const greenData = item =>  item.wf_status_code == 4;

        const pinkData = item =>  item.wf_status_code == 2;

        // const redData = item =>  item.wf_status_code == 1;

        const blueData = item =>  item.wf_status_code == 3;

        const colorGroups = [
          // {name: data1[0].message_text, filter: redData, color:am5.color(0xff0000)},
          {name: data1[1].message_text, filter: pinkData, color:am5.color(0xff00ff)},
          {name: data1[2].message_text, filter: blueData, color:am5.color(0x6794dc)},
          {name: data1[3].message_text, filter: greenData, color:am5.color(0x33bb64)},
        ]

        const seriesList = colorGroups.map(group => {

        const series = chart.series.push(
          am5xy.XYSeries.new(root, {
            name: group.name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueXField: "time",
            categoryYField: "machine_name",
            fill: group.color,
            stroke: group.color
          })
        )

        series.bullets.push((root, series, dataItem) => {
          const isVisible = group.filter(dataItem.dataContext);
          if(!isVisible) return undefined;
          const circle = am5.Circle.new(root, {
            radius: 15,
            fill: group.color,
            centerX: am5.p50,
            centerY: am5.p50,
            tooltipText: "[bold,#ffffff]{job_name}[/]\n[#ffffff]No. of Data Columns : {num_of_data_columns}\n[#ffffff]No. of Data Rows Processed : {num_of_data_rows_processed}\n[#ffffff]No. of Non-zero Data : {num_of_nonzero_data}"
          })

          return am5.Bullet.new(root, {
            sprite: circle
          })
        })

        series.data.setAll(data);
        return series;
        })

        let chartCursor = chart.set("cursor", am5xy.XYCursor.new(root, {
            behavior: "none",
            xAxis: xAxis
        }))
        chartCursor.lineY.set("visible",false);

        let scrollBarX = am5.Scrollbar.new(root, {
            orientation: "horizontal"
        })

        let scrollBarY = am5.Scrollbar.new(root, {
            orientation: "vertical"
        })

        chart.set("scrollbarX", scrollBarX);

        if(uniqueMachines.length > 15) {
        chart.set("scrollbarY", am5.Scrollbar.new(root, {
            orientation: "vertical",
            start: 0,
            end: 0.62
        }))
        } else {
            chart.set("scrollbarY", scrollBarY);
        }
 
        // let legend = chart.children.push(
        //   am5.Legend.new(root, {
        //     y: am5.percent(9),
        //     centerY: am5.percent(9),
        //     x: am5.percent(50),
        //     centerX: am5.percent(50),
        //     layout: root.gridLayout,
        //     maxColumns: 2,
        //     padding: 10,
        //     background: am5.RoundedRectangle.new(root, {
        //       fill: am5.color(0xffffff),
        //       fillOpacity: 1,
        //       stroke: am5.color(0x000000),
        //       strokeWidth: 1,
        //       cornerRadiusTL: 10,
        //       cornerRadiusTR: 10,
        //       cornerRadiusBL: 10,
        //       cornerRadiusBR: 10
        //     })
        //   })
        // )

        // legend.markerRectangles.template.setAll ({
        //       cornerRadiusTL: 10,
        //       cornerRadiusTR: 10,
        //       cornerRadiusBL: 10,
        //       cornerRadiusBR: 10
        // })

        // legend.data.setAll(seriesList)

        // const helpButton = am5.Container.new(root, {
        //   width: 30,
        //   height: 30,
        //   y: am5.percent(8.75),
        //   centerY: am5.percent(9),
        //   x: am5.percent(67),
        //   centerX: am5.percent(50),
        //   layout: root.gridLayoutLayout,
        //   background: am5.RoundedRectangle.new(root, {
        //     fill: am5.color(0x0d6efd)
        //   }),
        //   cursorOverStyle: "pointer",
        //   tooltipText: "Help",
        //   fill: am5.color(0x0d6efd),
        // })
  
        // const helpIcon = am5.Label.new(root, {
        //   text: "?",
        //   fontSize: 20,
        //   fill: am5.color(0xffffff),
        //   centerX: am5.percent(-3),
        //   centerY: am5.percent(10),
        //   // centerY: am5.p50
        // })
  
        // helpButton.children.push(helpIcon);
  
        // helpButton.events.on("click", () => {
        //   setVisible(true);
        // })

        // chart.children.push(helpButton);

       let legendContainer = chart.children.push(
        am5.Container.new(root, {
          layout: root.horizontalLayout,
          x: am5.percent(50),
          centerX: am5.percent(50),
          y: am5.percent(9),
          centerY: am5.percent(9),
          spacing: 20
        })
       )
       
        let legend = am5.Legend.new(root, {
            layout: root.gridLayout,
            maxWidth: 600,
            maxColumns: 2,
            padding: 10,
            background: am5.RoundedRectangle.new(root, {
              fill: am5.color(0xffffff),
              fillOpacity: 1,
              stroke: am5.color(0x000000),
              strokeWidth: 1,
              cornerRadiusTL: 10,
              cornerRadiusTR: 10,
              cornerRadiusBL: 10,
              cornerRadiusBR: 10
          })
    })

        legend.markerRectangles.template.setAll ({
              cornerRadiusTL: 10,
              cornerRadiusTR: 10,
              cornerRadiusBL: 10,
              cornerRadiusBR: 10
        })

        legend.data.setAll(seriesList)
        legendContainer.children.push(legend)
        
        const helpButton = am5.Container.new(root, {
          width: 30,
          height: 30,
          marginLeft: 20,
          background: am5.RoundedRectangle.new(root, {
            fill: am5.color(0x0d6efd)
          }),
          cursorOverStyle: "pointer",
          tooltipText: "Help",
          fill: am5.color(0x0d6efd),
        })
  
        const helpIcon = am5.Label.new(root, {
          text: "?",
          fontSize: 20,
          fill: am5.color(0xffffff),
          centerX: am5.percent(-3),
          centerY: am5.percent(10),
          // centerY: am5.p50
        })
  
        helpButton.children.push(helpIcon);
  
        helpButton.events.on("click", () => {
          setVisible(true);
        })
        legendContainer.children.push(helpButton)
        chart.appear(1000, 100);
        seriesList.forEach(s => s.appear(1000))

        return () => {
            root.dispose();
        }
    }, [chartData]);

    return (
    <div  ref={chartRef} className="bg-white shadow rounded chart-am5" style={{position: 'relative', height: '900px'}} >
        <Dialog
          header={<div style={{textAlign: 'center', width: '100%',fontSize:'1.5rem',}}>Legend Label Explanation</div>}
          visible={visible}
          onHide={() => setVisible(false)}
          style={{width : '1200px'}}
          modal
          >
            <div
            style={{
              textAlign: 'Left',
              fontSize:'1.2rem',
              paddingLeft: '50px',
              paddingRight: '50px',
            }}
            >
              <div dangerouslySetInnerHTML={{__html:data1[4].message_text}}/>
            </div>
          </Dialog>
          <div></div>
    </div>
  )
};

export default WorkFlowStatus;